import { timer as observableTimer } from 'rxjs';
import { AfterViewInit, Component, ChangeDetectorRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { take, map, takeWhile } from 'rxjs/operators';
import { AxisUtilsService, ModalService } from 'axis-components';

@Component({
  selector: 'app-fnol-timeout-modal',
  template: `
    <axis-modal #timeOut data-size="small" name="timeOut_Modal" id="idleOverlay" [closeOnEscape]="true">
      <axis-modal-header>
        <h1 class="_text-center" *ngIf="data?.headingMessage">{{ data.headingMessage }}</h1>
        <h1 class="_text-center" *ngIf="!data?.headingMessage" i18n="@@CyberWarningDefault">Warning</h1>
      </axis-modal-header>
      <axis-modal-content class="_text-center">
        <p id="tom_message_paragraph">
          <axis-icon data-color="danger" data-size="large" icon="access_time"></axis-icon>
          {{ data?.message }}
        </p>
        <p class="_text-light _text-xxxlarge">
          <span id="time_out_minutesDisplay">
            {{ (minutes && minutes <= 59) ? minutes : '00' }}
            <span>{{ minLabel }}</span>
            :
            {{ (seconds && seconds <= 59) ? seconds : '00' }}
            <span>{{ secLabel }}</span>
          </span>
        </p>
        <div *ngIf="!data?.hideBodyText && data?.bodyText">{{ data.bodyText }}</div>
        <div *ngIf="!data?.hideBodyText && !data?.bodyText" i18n="@@CyberContinueText">
          Please click “Continue” to keep working: or click “Log Off” to end your session now
        </div>
      </axis-modal-content>
      <axis-modal-footer>
        <div class="axis-btn-wrapper">
          <div class="axis-btn-wrapper-center">
            <button id="time_out_comtinue" axis-button data-kind="primary" (click)="continue('primary', false)">
              {{ data?.primaryButtonText }}
            </button>
            <button
              *ngIf="data?.customButtonText"
              id="modal_time_out_logout"
              axis-button
              data-kind="secondary"
              (click)="continue('secondary', false)"
            >
              {{ data.customButtonText }}
            </button>
          </div>
        </div>
      </axis-modal-footer>
    </axis-modal>
  `,
})
export class FnolIdleTimeoutModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('timeOut', { static: true }) timeOut: any;
  @Output() close = new EventEmitter<any>();

  @Input() data: any;
  private interval = 0;
  private ticks = 0;
  private isAlive = true;

  readonly minLabel = $localize`:@@fnolIdleMinLabel:min`;
  readonly secLabel = $localize`:@@fnolIdleSecLabel:secs`;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private axisUtilsService: AxisUtilsService,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    this.interval = Number(this.data?.timeoutSecs ?? 0);
    this.ticks = this.interval;
    this.timerCountDown();
    this._changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.timeOut?.open();
    }, 0);
  }

  get minutes(): number {
    return this.ticks > 0 ? Math.floor((this.ticks % (60 * 60)) / 60) : 0;
  }

  get seconds(): number {
    return this.ticks > 0 ? Math.floor(this.ticks % 60) : 0;
  }

  continue(buttonType: string, autoLoggedOut: boolean): void {
    this.axisUtilsService.close.next({ buttonType, autoLoggedOut });
    this.close.emit({ buttonType, autoLoggedOut });

    if (this.timeOut) {
      this.timeOut.close();
    }

    this.modalService.destroyModalComponent();
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }

  private timerCountDown(): void {
    if (!this.interval) {
      return;
    }

    const timer = observableTimer(1, 1000).pipe(take(this.interval), map(() => --this.interval));
    timer.pipe(takeWhile(() => this.isAlive)).subscribe((ticks) => {
      this.ticks = ticks;
      if (this.minutes === 0 && this.seconds === 0) {
        this.continue('secondary', true);
      }
      this._changeDetectorRef.detectChanges();
    });
  }
}